import { render, staticRenderFns } from "./EhpTab.vue?vue&type=template&id=6dcba236"
import script from "./EhpTab.vue?vue&type=script&lang=js"
export * from "./EhpTab.vue?vue&type=script&lang=js"
import style0 from "./EhpTab.vue?vue&type=style&index=0&id=6dcba236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports